// PATH: src/hooks/useOnlineStatus.ts — état de la connexion réseau du poste.
//
// Portée volontairement limitée : `navigator.onLine` dit que la MACHINE a une
// connexion, pas que le serveur répond. Un backend en panne derrière un wifi
// valide reste donc « en ligne » ici — c'est la notification collante d'échec
// d'écriture (api/notify) qui couvre ce cas, chaque opération sachant seule si
// elle a abouti.
import { useEffect, useState } from "react";

export const useOnlineStatus = (): boolean => {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === "undefined" || navigator.onLine === undefined ? true : navigator.onLine
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return online;
};
